import apiClient from "@shared/services/apiClient";

export type EegClipScissorsAction =
  | "clip_copy"
  | "archive_review"
  | "physical_prune";

export interface EegClipScissorsPreview {
  annotationType: "clip_segment";
  sourceRecordingId: string;
  annotationId: string;
  sourceStartSeconds: number;
  sourceEndSeconds: number;
  durationSeconds: number;
  padding: {
    beforeSeconds: number;
    afterSeconds: number;
  };
  actions: {
    clipCopy: { allowed: boolean };
    archiveReview: { allowed: boolean };
    physicalPrune: {
      allowed: boolean;
      blockers: string[];
    };
  };
  archiveManifest?: {
    manifest_id: string;
    archive_scope: string;
    verified_at?: string | null;
  } | null;
  holds?: {
    recording?: string | null;
    study?: string | null;
  };
}

export interface EegClipScissorsOperation {
  prune_operation_id: string;
  recording_id: string;
  annotation_id?: string | null;
  prune_mode: EegClipScissorsAction;
  operation_status: string;
  source_start_seconds: number;
  source_end_seconds: number;
  derived_recording_id?: string | null;
}

export async function previewEegClipScissors(input: {
  recordingId: string;
  annotationId: string;
  prePaddingSeconds: number;
  postPaddingSeconds: number;
}): Promise<EegClipScissorsPreview> {
  const response = await apiClient.post(
    `/eeg/recordings/${input.recordingId}/clip-scissors/preview`,
    {
      annotationId: input.annotationId,
      prePaddingSeconds: input.prePaddingSeconds,
      postPaddingSeconds: input.postPaddingSeconds,
    },
  );
  return response.data;
}

export async function createEegClipScissorsOperation(input: {
  recordingId: string;
  annotationId: string;
  action: EegClipScissorsAction;
  prePaddingSeconds: number;
  postPaddingSeconds: number;
  reason?: string;
  confirmation?: string;
}): Promise<EegClipScissorsOperation> {
  const response = await apiClient.post(
    `/eeg/recordings/${input.recordingId}/clip-scissors`,
    {
      annotationId: input.annotationId,
      action: input.action,
      prePaddingSeconds: input.prePaddingSeconds,
      postPaddingSeconds: input.postPaddingSeconds,
      reason: input.reason,
      confirmation: input.confirmation,
    },
  );
  return response.data;
}
